/**
 * Adds bullet / numbered prefixes to a pre-split line array.
 *
 * `listType` values:
 *   - 'bullet'    →  "• item"
 *   - 'numbered'  →  "1. item"   (counts only non-empty lines)
 *   - anything else (null/undefined) → returns the input unchanged
 *
 * Empty lines are preserved as-is so the renderer keeps blank-line spacing
 * and the numbering only advances on actual content. Trailing whitespace and
 * existing line contents are NOT mutated apart from the prepended prefix.
 *
 * Stays a pure function so every renderer (HTML, SVG, thumbnail) can call it.
 *
 * @param {string[]} lines
 * @param {string|null|undefined} listType
 * @returns {string[]}
 */
export function applyListPrefix(lines, listType) {
  if (!Array.isArray(lines) || !listType) return lines;
  if (listType !== 'bullet' && listType !== 'numbered') return lines;

  let counter = 0;
  return lines.map((line) => {
    if (line == null || line === '') return line;
    if (listType === 'bullet') return `•  ${line}`;
    counter += 1;
    return `${counter}.  ${line}`;
  });
}
